import * as React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { Notifications, Orders } from '../../store/slices';
import { setVoidLabel } from '../../api';
import { AppDialog } from '../ui';
import { errorMessage } from '../../lib/errorMessage';

/** Void one shipping label of the order (ShipStation). */
interface OrderVoidLabelProps {
    labelInfo?: { shipmentId: number | string } | null;
    isPopUp: boolean;
    popUpHandler: (closed?: boolean) => void;
}

export default function OrderVoidLabel({ labelInfo, isPopUp, popUpHandler }: OrderVoidLabelProps) {
    const { id, companyId } = useParams();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);

    const getOrder = () => {
        dispatch<any>(Orders.getOrder({ id: id || '', companyId: companyId || '' }));
    };

    const voidLabel = async () => {
        if (pending || !labelInfo?.shipmentId) return;
        setPending(true);
        try {
            await setVoidLabel({
                shipmentId: labelInfo.shipmentId,
                onSuccess: () => {
                    dispatch(Notifications.setNotifications({ text: 'Shipment voided', type: 'success' }));
                    popUpHandler(true);
                    getOrder();
                },
            });
        } catch (error) {
            dispatch(Notifications.setNotifications({ text: errorMessage(error), type: 'error' }));
        } finally {
            setPending(false);
        }
    };

    return (
        <AppDialog
            open={Boolean(isPopUp)}
            onClose={() => popUpHandler(true)}
            title="Void the shipping label?"
            description={`Shipment ${labelInfo?.shipmentId ?? ''} of order ${id} is voided in ShipStation. This cannot be undone.`}
            pending={pending}
            maxWidth="xs"
            actions={(
                <>
                    <Button variant="outlined" onClick={() => popUpHandler(true)}>Keep label</Button>
                    <Button variant="contained" color="error" onClick={voidLabel} disabled={pending}>Void label</Button>
                </>
            )}
        />
    );
}
